import { capabilities } from './capabilities.ts'
import { policies } from './policies.ts'
import { reports } from './reports.ts'
import { settings } from './settings.ts'
import { studio } from './studio.ts'
import { systems } from './systems.ts'

export const admin = {
  systems,
  policies,
  capabilities,
  reports,
  settings,
  studio
}
